/* DSL Bundle-builder cart writer — adds 3 variants + sets cart.attributes.bundle=true voor server-side discount-rule pickup */
(function(){
  var bundle = [];
  document.addEventListener("click", function(e){
    var slot = e.target.closest("[data-slot] [data-variant-id]");
    if (slot) {
      var slotEl = slot.closest("[data-slot]");
      var idx = parseInt(slotEl.dataset.slot, 10) - 1;
      bundle[idx] = parseInt(slot.dataset.variantId, 10);
      slotEl.dataset.filled = "1";
      slotEl.textContent = "Slot " + (idx+1) + " ✓";
      var btn = document.querySelector("[data-bundle-checkout]");
      if (btn && bundle.filter(Boolean).length === 3) btn.disabled = false;
      return;
    }
    if (e.target.matches("[data-bundle-checkout]")) {
      e.preventDefault();
      var items = bundle.filter(Boolean).map(function(id){ return {id: id, quantity: 1}; });
      if (items.length !== 3) return;
      fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({items: items})}).then(function(){
        return fetch("/cart/update.js", {method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({attributes: {bundle: "true", bundle_id: "mix3"}})});
      }).then(function(){
        if (window.DSL_AB) window.DSL_AB.track("bundle_checkout", {items: items.length});
        location.href = "/checkout?discount=BUNDLE3";
      });
    }
  });
})();